<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
    <el-backtop :visibility-height="100" target="#app"></el-backtop>
  </div>
</template>

<script>

export default {
  name: 'App',
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      projects_sprints: [],
      isRouterAlive: true
    }
  },
  computed: {
    userId() {
      return this.$store.state.login.userid
    },
  },

  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => (this.isRouterAlive = true))
    },
    //
    // getProjects() {
    //   jiraApi.getAllProject().then(res => {
    //     this.$store.commit('CHANGE_PROJECT', res.data.datas);
    //   })
    // // },
    // getDefaultMonth() {
    //   let time1 = new Date()
    //   let Y1 = time1.getFullYear()
    //   let M1 = ((time1.getMonth() + 1) > 9 ? (time1.getMonth() + 1) : '0' + (time1.getMonth() + 1))
    //   this.$store.commit('SET_MONTH', Y1 + '-' + M1)
    // }
  },
  created() {
    // this.getProjects()
    //this.getDefaultMonth()
  },
  mounted() {
    //不同标签的用户变化监测刷新
    let _this = this
    window.addEventListener("storage", function () {
      _this.$store.commit('FLASH_TOKEN')
    }, false);
  }
}
</script>

<style>
html, body {
  height: 100%;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
}
</style>
